// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getItSendStats as listItSendStatsAPI,
    getItSendStat as getItSendStatAPI,
    sendMail as sendMailAPI,
    addItSendStat as addItSendStatAPI,
    updateItSendStat as updateItSendStatAPI,
    deleteItSendStat as deleteItSendStatAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { itSendStatsApiResponseError, itSendStatsApiResponseSuccess } from './actions';
import { ItSendStatsActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getItSendStat({ payload: { id } }) {
    try {
        const response = yield call(getItSendStatAPI, id );
        const itSendStatItem = response.data.data;
        yield put(itSendStatsApiResponseSuccess(ItSendStatsActionTypes.GET_IT_SEND_STAT, itSendStatItem));
    } catch (error) {
        yield put(itSendStatsApiResponseError(ItSendStatsActionTypes.GET_IT_SEND_STAT, error));
    }
}

function* sendMail({payload:itSendStat}){
    try{
        const response = yield call(sendMailAPI,{...itSendStat})
        const itSendStatItem = response.data.data
        yield put(itSendStatsApiResponseSuccess(ItSendStatsActionTypes.IT_SEND_MAIL,itSendStatItem))
    } catch(error){
        yield put(itSendStatsApiResponseError(ItSendStatsActionTypes.IT_SEND_MAIL,error))
    }
}

function* addItSendStat({payload:itSendStat}){
    try{
        const response = yield call(addItSendStatAPI,{...itSendStat})
        const itSendStatItem = response.data.data
        yield put(itSendStatsApiResponseSuccess(ItSendStatsActionTypes.ADD_IT_SEND_STAT,itSendStatItem))
    } catch(error){
        yield put(itSendStatsApiResponseError(ItSendStatsActionTypes.ADD_IT_SEND_STAT,error))
    }
}

function* updateItSendStat({payload:itSendStat}){
    try{
        const response = yield call(updateItSendStatAPI,{...itSendStat})
        const itSendStatItem = response.data.data
        yield put(itSendStatsApiResponseSuccess(ItSendStatsActionTypes.UPDATE_IT_SEND_STAT,itSendStatItem))
    }catch(error){
        yield put(itSendStatsApiResponseError(ItSendStatsActionTypes.UPDATE_IT_SEND_STAT,error))
    }
}
function* deleteItSendStat({payload:{id}}){
    try{
        const response = yield call(deleteItSendStatAPI,id)
        const itSendStatItem = response.data.id
        yield put(itSendStatsApiResponseSuccess(ItSendStatsActionTypes.DELETE_IT_SEND_STAT,itSendStatItem))
    }catch(error){
        yield put(itSendStatsApiResponseError(ItSendStatsActionTypes.DELETE_IT_SEND_STAT,error))
    }
}

/**
 * List contactos
 */
function* listItSendStats({payload:params}) {
    try {
        const response = yield call(listItSendStatsAPI, { ...params });
        const listaItSendStats = response.data.data;
        yield put(itSendStatsApiResponseSuccess(ItSendStatsActionTypes.LIST_IT_SEND_STATS, listaItSendStats));
    } catch (error) {
        yield put(itSendStatsApiResponseError(ItSendStatsActionTypes.LIST_IT_SEND_STATS, error));
    }
}


export function* watchGetItSendStat(): any {
    yield takeEvery(ItSendStatsActionTypes.GET_IT_SEND_STAT, getItSendStat);
}

export function* watchListItSendStats(): any {
    yield takeEvery(ItSendStatsActionTypes.LIST_IT_SEND_STATS, listItSendStats);
}

export function* watchSendMail():any{
    yield takeEvery(ItSendStatsActionTypes.IT_SEND_MAIL,sendMail)
}

export function* watchAddItSendStat():any{
    yield takeEvery(ItSendStatsActionTypes.ADD_IT_SEND_STAT,addItSendStat)
}
export function* watchUpdateItSendStat():any{
    yield takeEvery(ItSendStatsActionTypes.UPDATE_IT_SEND_STAT,updateItSendStat)
}
export function* watchDeleteItSendStat():any{
    yield takeEvery(ItSendStatsActionTypes.DELETE_IT_SEND_STAT,deleteItSendStat)
}


function* itSendStatsSaga(): any {
    yield all([
        fork(watchGetItSendStat),
        fork(watchListItSendStats),
        fork(watchSendMail),
        fork(watchAddItSendStat),
        fork(watchUpdateItSendStat),
        fork(watchDeleteItSendStat),
    ]);
}

export default itSendStatsSaga;
